import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=471b3739&scoped=true&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&id=471b3739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b3739",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471b3739')) {
      api.createRecord('471b3739', component.options)
    } else {
      api.reload('471b3739', component.options)
    }
    module.hot.accept("./InternationalWire.vue?vue&type=template&id=471b3739&scoped=true&", function () {
      api.rerender('471b3739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/panels/InternationalWire.vue"
export default component.exports